import { FC } from 'react';
import { Button } from '@mui/material';
import SecondTypeButton from 'src/components/Items/button/SecondTypeButton';

interface IProps {
  type: string;
  openDelArray: boolean;
  setOpenDelArray: (openDelArray: boolean) => void;
  handleOpenModal: () => void;
  handleCloseDelAll: () => void;
}

const SPButtons: FC<IProps> = ({
  type,
  openDelArray,
  setOpenDelArray,
  handleOpenModal,
  handleCloseDelAll
}) => {
  return (
    <>
      {openDelArray && <SecondTypeButton onClick={handleCloseDelAll} children='Cancel' />}
      <Button
        variant='contained'
        onClick={openDelArray ? handleOpenModal : () => setOpenDelArray(true)}
      >
        Delete {openDelArray ? 'selected' : type}
      </Button>
    </>
  );
};
export default SPButtons;
